<template>
  <div :class="`depth-${depth}`">
    <div
      @click="nodeClicked"
      :class="['node', 'a-text', depth != 0 ? 'a-text-sm' : '']"
      :style="nodeStyle"
      v-ripple
    >
      <router-link v-if="!hasChildren" :to="linkTo" class="router-link">
        <!-- Icon change style based on depth -->
        <div id="icon" :style="iconStyle">
          <SvgIcon
            :iconColor="iconColor"
            :size="iconSize"
            :icon="icon"
          />
        </div>
        <!-- Item title -->
        <div
          :class="['text', `title-${depth}`, selected ? 'primary--text' : '']"
        >
          <div v-show="menuExpanded || isMobile">{{ node.title }}</div>
        </div>
      </router-link>
      <template v-else>
        <!-- Icon change style based on depth -->
        <div id="icon" :style="iconStyle">
          <SvgIcon
            :iconColor="iconColor"
            :size="iconSize"
            :icon="icon"
          />
        </div>
        <!-- Item title -->
        <div
          :class="['text', `title-${depth}`, selected ? 'primary--text' : '']"
        >
          <div v-show="menuExpanded || isMobile">{{ node.title }}</div>
        </div>
      </template>
      <!-- Arrow icon, shown only for first nodes -->
      <div
        v-if="depth == 0 && hasChildren && (menuExpanded || isMobile)"
        class="icon"
      >
        <v-icon :class="[{ rotateArrow: expanded }]" color="secondaryLight"
          >expand_more</v-icon
        >
        <!-- <SvgIcon v-if="expanded" size="12px" icon="arrow-up" />
          <SvgIcon v-else size="12px" :iconColor="$vuetify.theme.themes.light.secondary" icon="arrow-down" /> -->
      </div>
    </div>
    <v-expand-transition>
      <div v-show="expanded && hasChildren" class="border-left pt-3 pb-3">
        <!-- Recursive component -->
        <ItemTree
          v-for="child in node.child"
          :key="child.title"
          :node="child"
          :depth="depth + 1"
          :menuExpanded="menuExpanded"
        />
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: "ItemTree",
  props: {
    node: Object,
    depth: {
      type: Number,
      default: 0,
    },
    menuExpanded: Boolean,
    isMobile: Boolean,
  },
  data() {
    return {
      expanded: false,
      rowHeight: 60,
      selected: false,
      nodePath: "",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (!this.nodePath) {
          this.setNodePath();
        }
        this.selected = to.path == `/${this.nodePath}`;

        if (to.path.indexOf(this.node.name) != -1 && this.depth == 0) {
          this.selected = true;
        }
      },
    },
    menuExpanded() {
      if (!this.menuExpanded) this.expanded = false;
    },
  },

  computed: {
    hasChildren() {
      if (!this.node.child) return false;
      return Boolean(this.node.child.length);
    },
    nodeStyle() {
      const depth = this.depth;
      let height = `${this.rowHeight - depth * 5}px`;
      // let fontSize = `${14 - depth * 1}px`;
      let marginLeft = depth == 2 ? `${depth * 3}px` : "";

      return { height, marginLeft };
    },
    iconColor() {
      if (this.selected) {
        return this.$vuetify.theme.themes.light.primary;
      }
      return this.depth == 2
        ? this.$vuetify.theme.themes.light.gray
        : this.$vuetify.theme.themes.light.secondary;
    },
    iconSize(){
      return this.depth == 0 ? '26px' : '20px';
    },
    iconStyle() {
      if (this.selected && this.depth == 0) {
        return {
          backgroundColor: this.$vuetify.theme.themes.light.primaryLight+26,
          borderRadius: "5px",
        };
      }
    },
    linkTo() {
      let route = `/${this.node.routeName}`;
      if (this.node.args)
        this.node.args.forEach((arg) => {
          if (arg) route += `/${arg}`;
        });
      return route;
    },
    icon() {
      return this.node.icon;
    },
  },

  methods: {
    nodeClicked() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
      }
    },
    setNodePath() {
      const { routeName, args } = this.node;
      let aux = "";
      if (args && args.length) {
        args.forEach((arg) => {
          aux += `/${arg}`;
        });
      }
      this.nodePath = routeName + aux;
    },
    
  },
};
</script>

<style scoped>
.node {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px;
  cursor: pointer;
}

.depth-1,
.depth-2 {
  background-color: #f8f9fc;
  border-left: solid 2px #c6d8e3;
}
/* .depth-1:first-child {
  padding-top: 10px;
}
.depth-1:last-child {
  padding-bottom: 10px;
} */
.text {
  /* display: flex; */
  width: 90%;
  margin-left: 20px;
}

.border-left {
  padding-left: 27px;
  background-color: #f8f9fc;
}

.router-link {
  display: flex;
  color: inherit;
  text-decoration: none;
  align-items: center;
  width: 100%;
  height: 100%;
}
#icon {
  padding: 5px;
  margin: 0px -10px 0px -5px;
}

.rotateArrow {
  animation: 1s;
  transform: rotate(180deg);
}

.fade-enter-active {
  transition: opacity 0.3s;
}

.fade-leave-active {
  transition: opacity 0.125s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>